import React, { useEffect, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../store/actions/index";

import ErrorBoundary from "../hoc/ErrorBoundary.js";

import { withRouter } from "../shared/utility";
import DefaultLayout from "../components/layouts/DefaultLayout";
import Login from "../views/authentication/Login";
import ForgotPassword from "../views/authentication/ForgotPassword";
import ResetPassword from "../views/authentication/ResetPassword";
import AcceptTenantInvitation from "../views/authentication/AcceptTenantInvitation";
import { pageTitleForPath } from "../shared/documentTitle";
import { tenantAppTitle } from "../shared/tenantBranding";

function App(props) {
  const { authCheckState, router, tenant } = props;

  useEffect(() => {
    authCheckState();
  }, [authCheckState]);

  useEffect(() => {
    const pageTitle = pageTitleForPath(router.location.pathname, tenant);
    document.title = tenantAppTitle(tenant, pageTitle);
  }, [router.location.pathname, tenant]);

  let routes = null;

  const authToken = localStorage.getItem("authToken");

  let authRedirect = null;
  if (authToken) {
    if (props.isAuthenticated) {
      routes = (
        <Routes>
          <Route
            path="/accept-invitation"
            element={<AcceptTenantInvitation />}
          />
          <Route path="*" element={<DefaultLayout />} />
        </Routes>
      );
    }
  } else {
    routes = (
      <Routes>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/accept-invitation" element={<AcceptTenantInvitation />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <div className="h-full">
      {authRedirect}
      <ErrorBoundary>
        <Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
      </ErrorBoundary>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.authToken !== null,
    tenant: state.auth.tenant,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authCheckState: () => dispatch(actions.authCheckState()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
